<ui-empty-state icon="pause-circle" titleAs="h1" heading="Your access has been paused">
  <p uiEmptyStateBody>
    Your seat in {{ partnerName() }} has been suspended, so there's nothing here you can open at the
    moment. Your partner area owner can restore it.
  </p>

  @if (ownerEmail(); as email) {
    <a ui-link-button leadIcon="mail" [href]="'mailto:' + email">Email {{ email }}</a>
  }
</ui-empty-state>
